import React, { useMemo, forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Add as AddIcon } from '@mui/icons-material'
import ActionButton from '../common/button/Action.button'
import { ItemType, ColumnItem } from '../../models/props.models'
import List, { ListMode, ListModeType, ListRef, ListProps } from '../common/List.common'
import { Filter } from '../../models/props.models'

interface InventoryCheckWasteListProps extends Omit<ListProps, 'modes'> {
  onAddWaste: () => void
}

const InventoryCheckWasteList = forwardRef<ListRef, InventoryCheckWasteListProps>(({
  onAddWaste,
  getValues,
  onValueClick,
  ...listProps
}, ref) => {
  const { t } = useTranslation()
  
  const wasteFilters = useMemo(
    () => ({
      items: [
        {
          type: ItemType.search,
          key: 'search',
          props: {
            placeholder: 'Rechercher...',
          },
          grid: { xs: 12, sm: 6, md: 3 },
        },
      ],
    }),
    [],
  )

  const columns = useMemo<ColumnItem[]>(
    () => [
      {
        label: t('inventoryChecks:waste.list.wasteName'),
        key: 'name',
      },
      {
        label: t('inventoryChecks:waste.list.totalMass'),
        key: 'totalMass',
      },
      {
        label: t('inventoryChecks:waste.list.sortedOnWorkingSite'),
        key: 'sortedOnWorkingSite',
        formatValue: (value: boolean) =>
          value
            ? `${t(
                'inventoryChecks:waste.modalFormWaste.sortedOnWorkingSiteOptionA',
              )}`
            : `${t(
                'inventoryChecks:waste.modalFormWaste.sortedOnWorkingSiteOptionB',
              )}`,
      },
    ],
    [t],
  )

  return (
    <List
      {...listProps}
      getValues={getValues}
      filter={wasteFilters as Filter}
      onValueClick={onValueClick}
      ref={ref}
      additionalAction={
        <ActionButton
          startIcon={<AddIcon />}
          onClick={() => onAddWaste()}
          sx={{ whiteSpace: 'nowrap', width: { xs: '100%', sm: 'auto' } }}>
          {t('inventoryChecks:waste.action.addWaste')}
        </ActionButton>
      }
      modes={[
        {
          key: 'wasteList',
          type: ListModeType.table,
          columns: columns,
        } as ListMode,
      ]}
    />
  )
})

export default InventoryCheckWasteList
